import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=9e7c4bd6"
import script from "./Compare.vue?vue&type=script&setup=true&lang=js"
export * from "./Compare.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports